import { useTraders } from '@entities/trades/trader';
import type { ITraderTableColumns } from '@entities/trades/trader';
import { useRefetchAuto } from '@features/refetch-auto';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import { Table, THead, TBody, TableContainer, TableProvider } from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const TradersWidget = () => {
  const { refreshInterval, setRefreshInterval } = useRefetchAuto({
    storageKey: 'refetch-auto-traders',
  });

  const { traders, isLoading, isError, error, isFetching, refetch, filter } = useTraders({
    refreshInterval,
  });

  const { columnTitles, renderRow, renderFilterElement, getTheadAfter, getTbodyAfter } =
    useTableSettings({
      refetch,
      refreshInterval,
      setRefreshInterval,
    });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (traders) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ITraderTableColumns>
          columnTitles={columnTitles}
          storageKey='traders'
          {...filter}
        >
          <TableContainer>
            <Table>
              <THead
                items={traders.data}
                renderItem={renderFilterElement}
                afterColumns={getTheadAfter}
              />
              <TBody items={traders.data} renderItem={renderRow} afterColumns={getTbodyAfter} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={traders.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default TradersWidget;
